(() => {
  const catalogs = new Map();
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  function init(scope = document) {
    scope.querySelectorAll('[data-ws-gift-guide]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const buttons = [...root.querySelectorAll('[data-guide-recipient]')];
      const budget = root.querySelector('[data-guide-budget]');
      const kind = root.querySelector('[data-guide-kind]');
      const search = root.querySelector('[data-guide-search]');
      const grid = root.querySelector('[data-guide-grid]');
      const count = root.querySelector('[data-guide-count]');
      const more = root.querySelector('[data-guide-more]');
      const fallback = root.querySelector('[data-guide-fallback]');
      const empty = root.querySelector('[data-guide-empty]');
      const params = new URL(location.href).searchParams;
      if (params.get('budget') === '2000') params.set('budget', '3000');
      let recipient = buttons.some(button => button.dataset.guideRecipient === params.get('recipient')) ? params.get('recipient') : 'all';
      let products = null;
      let visibleLimit = 24;
      let requestId = 0;
      if ([...budget.options].some(option => option.value === params.get('budget'))) budget.value = params.get('budget');
      if ([...kind.options].some(option => option.value === params.get('kind'))) kind.value = params.get('kind');
      search.value = params.get('q') || '';
      function updateUrl() {
        const url = new URL(location.href);
        for (const [key, value, defaultValue] of [['recipient', recipient, 'all'], ['budget', budget.value, 'all'], ['kind', kind.value, 'all'], ['q', search.value.trim(), '']]) {
          value === defaultValue ? url.searchParams.delete(key) : url.searchParams.set(key, value);
        }
        history.replaceState(null, '', url);
      }
      function card(product) {
        const badge = product.available ? product.badge : root.dataset.soldOut;
        const price = (product.varies ? root.dataset.from + ' ' : '') + product.priceText;
        return `<div class="ws-guide__product"><article class="ws-silly-card"><a class="ws-silly-card__image" href="${escape(product.url)}" tabindex="-1" aria-hidden="true">${product.image ? `<img src="${escape(product.image)}" width="600" height="600" loading="lazy" alt="">` : ''}${badge ? `<span class="ws-silly-card__badge">${escape(badge)}</span>` : ''}</a><a class="ws-silly-card__title" href="${escape(product.url)}">${escape(product.title)}</a><div class="ws-silly-card__price"><span>${escape(price)}</span>${Number(product.compare) > Number(product.price) ? `<del>${escape(product.compareText)}</del>` : ''}</div>${!product.available ? `<span class="sr-only">${escape(root.dataset.soldOut)}</span>` : ''}</article></div>`;
      }
      function render() {
        if (!products) return;
        const terms = search.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
        const filtered = products.filter(product => (budget.value === 'all' || Number(product.price) <= Number(budget.value)) && (kind.value === 'all' || (kind.value === 'personal' ? product.personalizable : product.kind === kind.value)) && terms.every(term => product.title.toLocaleLowerCase().includes(term)));
        grid.innerHTML = filtered.slice(0, visibleLimit).map(card).join('');
        count.textContent = `${filtered.length} ${filtered.length === 1 ? root.dataset.oneCopy : root.dataset.allCopy}`;
        empty.hidden = filtered.length !== 0;
        more.hidden = filtered.length <= visibleLimit;
        updateUrl();
      }
      function catalog(handle) {
        const key = root.dataset.endpoint + '/' + handle;
        if (!catalogs.has(key)) {
          const fetchPage = async page => {
            const url = new URL(`${key}?view=ws-gift-data&page=${page}`, location.origin);
            const theme = window.Shopify?.theme;
            const preview = new URL(location.href).searchParams.get('preview_theme_id') || (['unpublished', 'development'].includes(theme?.role) ? theme.id : '');
            if (preview) url.searchParams.set('preview_theme_id', preview);
            const response = await fetch(url, {credentials:'same-origin'});
            if (!response.ok) throw new Error('Gift selection unavailable');
            const data = await response.json();
            if (!Array.isArray(data.products)) throw new Error('Invalid gift selection');
            return data;
          };
          catalogs.set(key, fetchPage(1).then(async first => {
            const rest = await Promise.all(Array.from({length:Math.max(0, first.pages - 1)}, (_, index) => fetchPage(index + 2)));
            return [...new Map([first, ...rest].flatMap(page => page.products).map(product => [product.id, product])).values()];
          }).catch(error => { catalogs.delete(key); throw error; }));
        }
        return catalogs.get(key);
      }
      async function choose() {
        const currentRequest = ++requestId;
        const button = buttons.find(button => button.dataset.guideRecipient === recipient);
        buttons.forEach(candidate => candidate.setAttribute('aria-pressed', String(candidate === button)));
        products = null;
        visibleLimit = 24;
        count.textContent = root.dataset.loading;
        grid.setAttribute('aria-busy', 'true');
        more.hidden = true;
        empty.hidden = true;
        fallback.href = root.dataset.endpoint + '/' + button.dataset.guideCollection;
        updateUrl();
        try {
          const loaded = await catalog(button.dataset.guideCollection);
          if (currentRequest !== requestId) return;
          products = loaded;
          render();
        } catch (error) {
          if (currentRequest !== requestId) return;
          console.warn('Weinspirits gift guide:', error);
          grid.innerHTML = '';
          count.textContent = root.dataset.loadError;
        } finally {
          if (currentRequest === requestId) grid.removeAttribute('aria-busy');
        }
      }
      buttons.forEach(button => button.addEventListener('click', () => { recipient = button.dataset.guideRecipient; choose(); }));
      for (const control of [budget, kind]) control.addEventListener('change', () => { visibleLimit = 24; render(); });
      search.addEventListener('input', () => { visibleLimit = 24; render(); });
      more.addEventListener('click', () => { visibleLimit += 24; render(); });
      root.querySelector('[data-guide-reset]').addEventListener('click', () => { recipient = 'all'; budget.value = 'all'; kind.value = 'all'; search.value = ''; choose(); });
      choose();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
